export class TranslateServiceStub {

	currentLang: 'FR';

	instant() {
	}

}
